<template>
  <span
    v-tippy="{ content: t('company-not-migrated'), placement: 'top' }"
    class="tw-inline-flex tw-items-center"
    :data-test-id="dataTestId"
  >
    <CbIconError :width="16" />
  </span>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { CbIconError } from "@/components/cybersentriq-ui/icons";

const { t } = useI18n();

defineProps<{ dataTestId?: string }>();
</script>
